// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2135":"80a5ed3fe8b38d12","2901":"4dabd7e97ece42e8"}[chunkId] + ".css";
};